import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik"
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { Step } from "../../../components/Step/Step";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getPeopleForm } from "../../../services/autofillService";
import { getClassName } from "../../../utils";
import { questions, videos } from "../../../content/purpose/people";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { UpButton } from "../../../components/Buttons/UpButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { Oval } from "react-loader-spinner";
import { submitPeople } from "../../../services/answersService";

export const PurposePeople = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({
        people1: [
            {
                people: ''
            },
        ],
        people2: [
            {
                target: ''
            },
        ],
        combine: '',
    });
    const [activeStep, setActiveStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = values => {
        setIsLoading(true);
        submitPeople(values).then(response => {
            setIsLoading(false);
            navigate("/flow/purpose/impact");
        }).catch(err => {
            setIsLoading(false);
        })
    };

    const handleUpClick = () => {
        setActiveStep(activeStep - 1);
        if (activeStep === 2) {
            dispatch(setProgress(23))
        } else if (activeStep === 1) {
            dispatch(setProgress(20))
        }
    }

    const handleDownClick = () => {
        setActiveStep(activeStep + 1);
        if (activeStep === 0) {
            dispatch(setProgress(23));
        } else if (activeStep === 1) {
            dispatch(setProgress(26));
        }
    }

    useEffect(() => {
        dispatch(setProgress(20))
        getPeopleForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.error(err);
        })
    }, []);
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <Form className="form">
                            <section className="flex flex-col items-center justify-center w-full h-full">
                                <Step className={getClassName(0, activeStep)} question={questions.people1} url={videos.people1Video.url}>
                                    <FieldArray name="people1">
                                        {({ insert, remove, push }) => (
                                            <>
                                                {values.people1.length > 0 &&
                                                    values.people1.map((people, index) => (
                                                        <>
                                                            <Field
                                                                name={`people1.${index}.people`}
                                                                placeholder="Personality trait / Adjective of those people"
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                            />
                                                            <ErrorMessage name={`people1.${index}.people`} component="div" className="required" />
                                                        </>
                                                    ))
                                                }
                                                <AddMore onClick={() => push({ people: '' })} />
                                            </>
                                        )}
                                    </FieldArray>
                                </Step>
                                <Step className={getClassName(1, activeStep)} question={questions.people2} url={videos.people2Video.url}>
                                    <FieldArray name="people2">
                                        {({ insert, remove, push }) => (
                                            <>
                                                {values.people2.length > 0 &&
                                                    values.people2.map((target, index) => (
                                                        <>
                                                            <Field
                                                                name={`people2.${index}.target`}
                                                                placeholder="Target audience"
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                            />
                                                            <ErrorMessage name={`people2.${index}.target`} component="div" className="required" />
                                                        </>
                                                    ))
                                                }
                                                <AddMore onClick={() => push({ target: '' })} />
                                            </>
                                        )}
                                    </FieldArray>
                                </Step>
                                <Step className={getClassName(2, activeStep)} question={questions.combine} url={videos.combineVideo.url}>
                                    <Field
                                        name="combine"
                                        placeholder="Adjective + Name"
                                        className="has-border-bottom mt-3"
                                    />
                                    <ErrorMessage name="combine" component="div" className="required" />
                                </Step>
                            </section>
                            <Buttons link="/flow/purpose/passion">
                                <UpButton onClick={handleUpClick} disabled={activeStep === 0} />
                                {(activeStep === 2) ? (
                                    <button type="submit" className="btn yellow-cta">
                                        {isLoading ? <Oval
                                            height={30}
                                            width={50}
                                            color="black"
                                            secondaryColor="black"
                                        /> : (
                                            <span>
                                                Next
                                            </span>
                                        )}
                                    </button>
                                ) : (
                                    <DownButton onClick={handleDownClick} disabled={activeStep === 2} />
                                )}
                            </Buttons>
                        </Form>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Purpose" />
        </>
    )
}